import * as Yup from "yup";

const filtroImpressaoValidator = Yup.object().shape({
  etiquetaId: Yup.number().required("Modelo de Etiqueta").nullable(),
  produtoId: Yup.number().when("tipoFiltro", (tipoFiltro) => {
    return tipoFiltro === "produto"
      ? Yup.number().required("Produto")
      : Yup.number().nullable();
  }),
  nfEntradaId: Yup.number().when("tipoFiltro", (tipoFiltro) => {
    return tipoFiltro === "nfEntrada"
      ? Yup.number().required("NF de Entrada")
      : Yup.number().nullable();
  }),
}).test(
  "grupoProduto",
  "No mínimo, o preenchimento de um dos campos",
  function (value) {
    if (value.tipoFiltro !== "grupoProduto") return true;

    const isValid = 
      value.grupoProdutoId ||
      value.subgrupoProdutoId ||
      value.familiaProdutoId ||
      value.subfamiliaProdutoId
    ;
    if (isValid) return true;

    return this.createError({
      path: "grupoProduto",
      message: "No mínimo, o preenchimento de um dos campos",
    });
  }
);

export default filtroImpressaoValidator;
